import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { ZapierTemplateIntegrationCard } from './ZapierTemplateIntegrationCard';
import { zapierTemplateIntegrationsByGroup } from './zapierTemplateIntegrations';
export function ZapierTemplateIntegrationCards(param) {
    let { group } = param;
    const { ZAPIER_TEMPLATE_INTEGRATIONS } = useFeatureFlags();
    if (!ZAPIER_TEMPLATE_INTEGRATIONS) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: zapierTemplateIntegrationsByGroup[group].map((integration)=>/*#__PURE__*/ _jsx(ZapierTemplateIntegrationCard, {
                integration: integration
            }, integration.key))
    });
}
